import * as React from 'react';
import { graphql, useStaticQuery, Link } from 'gatsby';
import { moreButton } from './more-button.module.css';
import * as nodesUtils from '../../utils/nodes';

export function MoreButton({
  className,
  segmentType,
  segmentKey,
  catalogType,
  catalogId,
  ...props
}) {
  // static query
  const data = useStaticQuery(graphql`
    query {
      catalogs: allDatoCmsCatalog {
        edges {
          node {
            id
            title
            originalId
          }
        }
      }
      siteSetting: datoCmsSiteSetting {
        catalog {
          id
          title
          originalId
        }
        catalogAlt {
          id
          title
          originalId
        }
      }
    }
  `);
  const { catalogs, siteSetting } = data;
  const allCatalogs = catalogs ? catalogs.edges : [];

  // parameter handling
  const baseSearchPath = nodesUtils.getSearchPathFromSegment(
    segmentType,
    segmentKey,
    catalogType,
    siteSetting,
    allCatalogs
  );
  const searchPath = `${baseSearchPath}#more`;

  return <Link to={searchPath} className={[className, moreButton].join(' ')} {...props} />;
}
